// src/Layout/ServicesLayout.js
import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import AppShell from "../Components/AppShell";
import SideNav from "../Components/SideNav";
import Breadcrumb from "../Components/BreadCrumb";
import Footer from "../Components/Footer";
import ServiceGuard from "../Components/ServiceGuard";
import PendingUsersModal from "../Components/PendingUsersModal";
import { useAuth } from "../Context/AuthContext";
import servicesConfig from "../config/ServicesConfig";

const ServicesLayout = ({ children, serviceKey: propServiceKey }) => {
  const location = useLocation();
  const { pendingUsers, showPendingModal, setShowPendingModal } = useAuth();

  // Extract serviceKey from URL path if not provided via props
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const urlServiceKey = pathSegments[0];
  const serviceKey = propServiceKey || urlServiceKey;

  // Determine if this page is a "service page"
  const isServicePage =
    serviceKey && !["home", "subscription", "unauthorized"].includes(serviceKey);

  // Resolve accessibility key from config (null for admin/system pages — no guard)
  const accessKey = servicesConfig[serviceKey]?.accessKey || null;

  // The frame (top bar, sidebar, drawer on small screens) is AppShell.jsx, shared with Home.jsx.
  return (
    <AppShell
      showSidebar={isServicePage}
      renderSidebar={({ collapsed }) => (
        <SideNav serviceKeySelected={serviceKey} collapsed={collapsed} />
      )}
      before={showPendingModal && (
        <PendingUsersModal
          users={pendingUsers}
          onClose={() => setShowPendingModal(false)}
        />
      )}
    >
      <Breadcrumb />
      <ServiceGuard
        accessKey={accessKey}
        serviceKey={serviceKey}
        serviceName={servicesConfig[serviceKey]?.label || serviceKey}
      >
        {/* If children contain <Outlet />, render it with context */}
        {React.Children.toArray(children).some(
          (child) => child.type === Outlet
        ) ? (
          <Outlet context={{ serviceKey }} />
        ) : (
          children
        )}
      </ServiceGuard>
      <Footer />
    </AppShell>
  );
};

export default ServicesLayout;
